import { CSSProperties, ReactNode } from 'react';
import { Footer2022, Intro2022 } from './components';
import { use2022Page } from './shared';

type AwardCategory = { title: ReactNode; image: string };

const categories: AwardCategory[] = [
  { title: 'Arts and Culture', image: '/2022/images/ArtandCulture.gif' },
  { title: 'Educational Technology (EdTech)', image: '/2022/images/EducationTechnology.gif' },
  { title: 'Geron Technology (GeronTech)', image: '/2022/images/GeronTech.gif' },
  { title: 'Health Technology (HealthTech)', image: '/2022/images/HealthTech.gif' },
  { title: <>Marketing Technology (MarTech) (Smart Retail / <span style={{ whiteSpace: 'nowrap' }}>e-Commerce</span>)</>, image: '/2022/images/MarketingTechnology.gif' },
  { title: 'Metaverse', image: '/2022/images/Metaverse1.gif' },
  { title: 'Property Technology (PropTech)', image: '/2022/images/PropertyTech.gif' },
  { title: 'Small and Medium Business (Tourism / Human Resources / Administration)', image: '/2022/images/SmallAndMediumBusiness.gif' },
  { title: 'Smart Building / Environment (EnviroTech) / Green Technology', image: '/2022/images/SmartBuildingEnvironment.gif' },
  { title: 'Smart Government', image: '/2022/images/SmartGovernment1.gif' },
  { title: 'Smart Mobility', image: '/2022/images/SmartMobility1.gif' },
  { title: 'Smart Workforce Management', image: '/2022/images/SmartWorkforceManagement.gif' },
  { title: 'Wearable / Internet of Things (IOT) / Robotics', image: '/2022/images/Wearable.gif' },
];

const benefits = [
  'All Award Winners will be featured prominently on the Smart Living Partnership Awards 2022 minisite',
  'All Award Winners will get credible awards with reputable recognition and appreciation',
  'Use of the widely recognised branded winners logo on your website and marketing / publicity materials',
  'Supported by major media partners and recognised quality branded sponsors',
  'Awards supported by over 10 professional bodies and independently judged by a panel of over 10 experts',
  'Media coverage reaching a cross platform audience',
];

const swiperVars = {
  '--swiper-navigation-color': '#fff',
  '--swiper-pagination-color': '#fff',
} as CSSProperties;

const Awards2022 = () => {
  use2022Page({ cate: 'awards', lang: 'en', title: 'Smart Living Partnership Awards 2022 - Awards' });
  return (
    <div className="slpa2022-root">
      <Intro2022 lang="en" />
      <section id="LeadIn"><div className="wave_bg"><img src="/2022/images/wave_bg.png" alt="" /></div></section>
      <section id="AwardCategory">
        <div className="AwardCategory_info">
          <div className="AwardCategory_Title">AWARD CATEGORIES</div>
          <div className="AwardCategory_TitleLine"><div className="AwardCategory_TitleLineDot"><img src="/2022/images/linedot.png" alt="" /></div></div>
          <div className="AwardCategory_BubbleTable">
            <div style={swiperVars} className="swiper mySwiper2">
              <div thumbs-slider="" className="swiper mySwiper">
                <div className="swiper-wrapper">
                  {categories.map((item) => (
                    <div className="swiper-slide" key={`title-${item.image}`}>
                      <div className="swiper-slide-title">{item.title}</div>
                    </div>
                  ))}
                </div>
              </div>
              <div className="swiper-wrapper">
                {categories.map((item) => (
                  <div className="swiper-slide" key={`image-${item.image}`}>
                    <div className="swiper-slide-image"><img src={item.image} alt="" /></div>
                  </div>
                ))}
              </div>
              <div className="swiper-button-next" aria-label="next"><svg className="swiper-nav-icon" viewBox="0 0 24 24" aria-hidden="true"><path d="M8 4L16 12L8 20"></path></svg></div>
              <div className="swiper-button-prev" aria-label="previous"><svg className="swiper-nav-icon" viewBox="0 0 24 24" aria-hidden="true"><path d="M16 4L8 12L16 20"></path></svg></div>
            </div>
          </div>
        </div>
      </section>
      <section id="AwardBenifit">
        <div className="AwardBenifit_info">
          <div className="AwardBenifit_Title">BENEFITS OF THE AWARD</div>
          <div className="AwardBenifit_TitleLine"><div className="AwardBenifit_TitleLineDot"><img src="/2022/images/linedot.png" alt="" /></div></div>
          <div className="AwardBenifit_Table">
            {benefits.map((text) => (
              <div className="AwardBenifit_Benifit" key={text}><p>{text}</p></div>
            ))}
          </div>
        </div>
      </section>
      <Footer2022 lang="en" />
    </div>
  );
};

export default Awards2022;

